import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  isAuthenticated(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return !!localStorage.getItem('token');
    }
    return false;
  }

  isAdmin(): boolean {
    return this.checkForRole("Admin")
  }

  isSales(): boolean {
    return this.checkForRole("Sales")
  }

  isMarketing(): boolean {
    return this.checkForRole("Marketing")
  }

  private checkForRole(role: string): boolean {
    if (isPlatformBrowser(this.platformId)) {
      let token = localStorage.getItem('token');
      if (!token || token.split('.').length < 2) {
        return false;
      }
      try {
        const decoded: any = jwtDecode(token);
        let userRole = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        if (Array.isArray(userRole)) {
          return userRole.some((data: string) => data === role);
        } else {
          return userRole === role;
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        return false;
      }
    }
    return false
  }
}
